export const formatCurrency = (amount: number | null | undefined): string => {
    if (amount == null || !Number.isFinite(amount)) {
        return "—";
    }

    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    }).format(amount);
};
